export default "__VITE_ASSET__eA$5TSwd__"